<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.show" persistent max-width="380">
      <v-card>
        <v-card-title id="dialog-collect-title">
          <v-img
            class="modal-icon"
            max-width="32"
            src="../../assets/images/icons/icon-01-1.png"
          ></v-img>
          <span class="title white--text">{{ trans.title }}</span>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" fab outlined dark small @click="close">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text flat style="padding: 0 16px 0">
          <div>
            <v-stepper :value="state" alt-labels class="mt-4">
              <v-stepper-header>
                <v-stepper-step step="1" :complete="state > 1"
                  >{{ trans.step_1_1 }}<br />{{ trans.step_1_2 }}</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="2" :complete="state > 2"
                  >{{ trans.step_2_1 }}<br />{{ trans.step_2_2 }}</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="3"
                  >{{ trans.step_3_1 }}<br />{{ trans.step_3_2 }}</v-stepper-step
                >
              </v-stepper-header>
            </v-stepper>
          </div>
          <div v-if="state === 1">
            <v-form>
              <v-text-field
                solo
                :placeholder="trans.placeholder_phone_or_password"
                v-model="pickupCode"
                required
                v-mask="'##########'"
              ></v-text-field>
            </v-form>
          </div>
          <div v-if="state === 2">
            <v-form ref="formOtp">
              <v-text-field
                solo
                :placeholder="trans.placeholder_confirm_otp"
                maxlength="6"
                v-model="otp"
                required
                :error-messages="errors"
              ></v-text-field>
            </v-form>
          </div>
          <div v-if="state === 3">
            <v-container>
              <v-row>
                <v-col align="center">
                  <h2 class="red--text">{{ trans.all_locker }}</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col align="right">
                  <h2>{{ trans.quantity }}</h2>
                </v-col>
                <v-col align="center">
                  <h2>{{ locker.totals }}</h2>
                </v-col>
                <v-col align="center">
                  <h2>{{ trans.locker }}</h2>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col align="center" class="pa-6">
                  <h2 class="red--text">{{ trans.open_locker }}</h2>
                </v-col>
              </v-row>
              <v-row>
                <template v-for="n in locker.cells">
                  <v-col :key="n.cellno" cols="3">
                    <BtnLock
                      :btn="btn"
                      :lockerId="1"
                      :cellNo="n.cellno"
                      v-on:open="openLocker(n)"
                    ></BtnLock>
                    <p class="pa-3 text-center">{{ trans.lcoker_no }} {{ n.cellno }}</p>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </div>
        </v-card-text>
        <v-card-actions v-if="state === 1">
          <v-container>
            <v-row cols="10">
              <v-col class="sm-6">
                <v-btn outlined width="100%" @click="close">Cancel</v-btn>
              </v-col>
              <v-col class="sm-6">
                <v-btn
                  color="error"
                  width="100%"
                  @click="submitPin"
                  :disabled="pickupCode.length < 6"
                  >OK</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <v-card-actions v-if="state === 2">
          <v-container>
            <v-row cols="10">
              <v-col class="sm-6">
                <v-btn outlined width="100%" @click="back(1)"
                  >Back</v-btn
                >
              </v-col>
              <v-col class="sm-6">
                <v-btn
                  :disabled="otp.length < 4"
                  color="error"
                  width="100%"
                  @click="submitOtp"
                  >OK</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <v-card-actions v-if="state === 3">
          <v-container>
            <v-row no-gutters>
              <v-col align="center">
                <h3 class="success--text">* {{ trans.collect_and_close }}</h3>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mask } from "vue-the-mask";
import BtnLock from "../Button/BtnLock";

export default {
  components: {
    BtnLock,
  },
  directives: { mask },
  props: {
    rules: Object,
    dialog: Object,
    locker: Object,
    trans: Object,
  },
  data() {
    return {
      mask: "##########",
      state: 1,
      btn: {
        width: 64,
        height: 64,
      },
      pickupCode: "",
      otp: "",
      errors: "",
      totals: 0
    };
  },
  mounted() {},
  methods: {
    submitPin() {
      this.$emit("getLocker", this.pickupCode);
    },
    submitOtp() {
      if (!this.locker.otp.includes(this.otp)) {
        this.errors = this.trans.otp_wrong;
      } else {
        this.state = 3;
      }
    },
    openLocker(value) {
      this.$emit("openLocker", value, "P");
    },
    close() {
      this.pickupCode = "";
      this.state = 1;
      this.$emit("close");
    },
    async back(step) {
      this.$set(this.dialog, 'step', 1);
      await this.$nextTick();
      this.pickupCode = "";
      this.otp = "";
    }
  },
  watch: {
    "dialog.step": function(newVal) {
      this.state = newVal;
    },
    "otp": function(newVal) {
      if (newVal.length == 0) {
        this.errors = "";
      }
    },
  },
};
</script>
<style scoped>
span.title {
  font-family: "Roboto", "Kanit", sans-serif !important;
}
.v-application p {
  margin-bottom: 0;
}
</style>
